// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__2yWli","item":"PaymentsMobile_item__36OHs","label":"PaymentsMobile_label__1WBJL","amount":"PaymentsMobile_amount__1e5no"};